import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import ProductGridCard from "@/components/feature/ProductGridCard";
import { isLiveProduct, useProducts, useSiteText } from "@/lib/siteContent";
import type { Product } from "@/types";

/**
 * Vitrine da home: 12 produtos que NÃO aparecem na seção "Acabaram de chegar",
 * para que nenhuma fotografia se repita entre as duas seções.
 */
export const selectionIds = [
  "sandalia-plataforma-couro",
  "scarpin-classico-salto-medio",
  "sapatilha-classica-bico-redondo",
  "mule-salto-baixo",
  "mocassim-classico",
  "tenis-casual-couro",
  "rasteira-minimalista",
  "papete-couro",
  "bota-cano-curto",
  "bolsa-mao-estruturada",
  "cinto-fino",
  "brinco-escultural",
];

export default function Selection() {
  const products = useProducts().filter(isLiveProduct);
  const items = selectionIds
    .map((id) => products.find((product) => product.id === id))
    .filter((product): product is Product => Boolean(product));

  const eyebrow = useSiteText("selection.eyebrow", "Vitrine");
  const title = useSiteText("selection.title", "Seleção Auréa");
  const text = useSiteText(
    "selection.text",
    "Uma amostra da coleção, com calçados de vários tipos e acessórios para completar o look. Toque em “Ver detalhes” para escolher cor, numeração e adicionar à sacola.",
  );

  return (
    <section id="selecao" className="w-full scroll-mt-24 bg-background-100" aria-label="Seleção Auréa">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading eyebrow={eyebrow} title={title} text={text} />

          <div
            data-product-shop
            className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
          >
            {items.map((product, index) => (
              <Reveal key={product.id} delay={(index % 3) * 80}>
                <ProductGridCard product={product} />
              </Reveal>
            ))}
          </div>

          <div className="mt-12 flex justify-center">
            <Link
              to="/novidades"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-7 py-3.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              Ver todas as novidades
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}